import React, { ReactElement } from 'react';

type Props = {
    children: ReactElement;
};

const WithClientMode: React.FC<Props> = ({ children }) =>
    process.env.REACT_APP_IS_ADMIN === 'false' ? children : null;

export { WithClientMode };
